var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { mapGetters, mapActions } from 'vuex';
import { Loading } from 'element-ui';
import CommonService from "../../api/CommonService";
import ShopActivityService from '../../api/ShopActivityService';
import RecordTable from './components/recordTable';
import { UrlHelper } from '../../helper/UrlWrapper';
import _ from 'lodash';
var initFilterData = {
    shop_id: null,
    order_id: null,
    business_id: null
};
var ShopActivityRecord = (function (_super) {
    __extends(ShopActivityRecord, _super);
    function ShopActivityRecord() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableHeight = 300;
        _this.activity_id = '';
        _this.formData = {};
        _this.summaryData = {
            business_count: null,
            order_count: null,
            order_money: null,
            activity_point: null
        };
        _this.filterData = __assign({}, initFilterData);
        _this.shopList = [];
        _this.total = 0;
        _this.listData = [];
        _this.isRefreshRecord = true;
        _this.buttonAuth = {
            Export: false,
        };
        _this.clientList = [];
        return _this;
    }
    ShopActivityRecord.prototype.normalizer = function (id, name) {
        if (id === void 0) { id = "id"; }
        if (name === void 0) { name = "name"; }
        return function (node) { return ({
            id: node[id],
            label: node[name],
            children: node.children,
        }); };
    };
    ShopActivityRecord.prototype.normalizerClient = function (node) {
        return {
            id: node.business_id,
            label: node.business_name,
            children: node.children,
        };
    };
    ShopActivityRecord.prototype.created = function () {
        var _this = this;
        this.service = ShopActivityService.getInstance();
        this.commonService = CommonService.getInstance();
        this.getDetail();
        this.search();
        this.getShop();
        this.getBusiness();
        this.getAuth('310004').then(function (pageAuth) {
            Object.assign(_this.buttonAuth, pageAuth && pageAuth.Auth);
        });
    };
    ShopActivityRecord.prototype.mounted = function () {
        var _this = this;
        var timeout = setTimeout(function () {
            clearTimeout(timeout);
            _this.tableHeight = document.documentElement.clientHeight - 325;
        }, 300);
    };
    ShopActivityRecord.prototype.getShop = function () {
        var _this = this;
        var params = {
            area_ids: 86000000,
            real: '0',
        };
        this.commonService.getShop(params).then(function (res) {
            if (res.data.success) {
                var depot = res.data && res.data.data;
                _this.shopList = depot;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    ShopActivityRecord.prototype.getBusiness = function () {
        var _this = this;
        this.commonService.getGroupchilds().then(function (res) {
            if (res.data.success) {
                var data = res.data;
                var list = data.data;
                list.forEach(function (item, index) {
                    item.business_id = new Date().getTime() + index;
                    item.business_name = item.group_name;
                });
                _this.clientList = list;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    ShopActivityRecord.prototype.getDetail = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = {
            activity_id: this.activity_id,
        };
        this.service
            .getDetail(params)
            .then(function (res) {
            loadingInstance.close();
            var data = res.data && res.data.data;
            _this.formData = data;
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    ShopActivityRecord.prototype.search = function () {
        this.$refs.pagination && this.$refs.pagination.clear();
        this.getActCusList();
    };
    ShopActivityRecord.prototype.reset = function () {
        this.filterData = __assign({}, initFilterData);
    };
    ShopActivityRecord.prototype.exportData = function () {
        var shop_id = (this.filterData && this.filterData.shop_id) || [];
        var shop_ids = shop_id.join(',');
        var order_id = (this.filterData && this.filterData.order_id) || '';
        var url = "/supplierclientapi/shopping_activity/export?activity_id=" + this.activity_id + "&shop_ids=" + shop_ids + "&keyword=" + order_id;
        url = UrlHelper.addParam(url, "token", this.user.token);
        location.href = url;
        console.log(url);
        window._czc.push(['_trackEvent', '营销活动', '参与记录导出']);
    };
    ShopActivityRecord.prototype.getActCusList = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        var loadingInstance = Loading.service({ fullscreen: true });
        var _a = this.filterData, shop_id = _a.shop_id, order_id = _a.order_id, business_id = _a.business_id;
        var params = {
            activity_id: this.activity_id,
            shop_ids: (shop_id || []).join(","),
            keyword: order_id,
            business_id: (business_id || []).join(',')
        };
        this.service
            .getActCusList(Object.assign({}, params, pager))
            .then(function (res) {
            loadingInstance.close();
            _this.isRefreshRecord = false;
            _this.summaryData = {
                business_count: res.data && res.data.business_count,
                order_count: res.data && res.data.order_count,
                order_money: res.data && res.data.order_money,
                activity_point: res.data && res.data.activity_point,
            };
            var tableData = (res.data && Array.isArray(res.data.data)) ? res.data.data : [];
            _.forEach(tableData, function (item) {
                item.listOrders = [];
                item.listOrdersTotal = 0;
            });
            _this.listData = tableData;
            _this.total = res.data && res.data.total;
            setTimeout(function () {
                _this.isRefreshRecord = true;
            }, 10);
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    ShopActivityRecord.prototype.pageChange = function (pager) {
        this.getActCusList(pager);
    };
    ShopActivityRecord = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                user: 'user',
            })),
            methods: __assign({}, mapActions(["getAuth"])),
            components: {
                RecordTable: RecordTable
            },
        })
    ], ShopActivityRecord);
    return ShopActivityRecord;
}(Vue));
export default ShopActivityRecord;
